import styled from "@emotion/styled";
import React from "react";
import { SingleCheckBox, TextInput } from "../../form";
import { Checkbox } from "antd";
import { ErrorMessage } from "../../form/TextInput";
import { Controller } from "react-hook-form";

const CheckboxWrapper = styled.div(() => ({
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
}));

const ToolWrapper = styled.div(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem 1.6rem",
}));

const CautionWrapper = styled.div(() => ({
  padding: "2rem",
  fontSize: "1.2rem",
  backgroundColor: "#f5f5f5",
  borderRadius: "1rem",

  b: {
    display: "block",
    marginBottom: "0.4rem",
    fontWeight: "bold",
  },
}));

const ContestCheckBoxGroup = ({
  control,
  isAI,
  setIsAI,
  aiToolError,
  tools,
  setTools,
  watch,
}) => {
  return (
    <CheckboxWrapper>
      <section>
        <label>AI 활용 여부 (AI를 활용한 영상 출품 가능)</label>

        <div>
          <Checkbox
            checked={isAI.yes}
            onChange={() => setIsAI({ yes: !isAI.yes, no: isAI.yes })}
          >
            예
          </Checkbox>

          <Checkbox
            checked={isAI.no}
            onChange={() => setIsAI({ no: !isAI.no, yes: isAI.no })}
          >
            아니오
          </Checkbox>
        </div>
      </section>

      {isAI.yes && (
        <section>
          <label>AI 활용 도구</label>

          {aiToolError && (
            <ErrorMessage>사용한 AI를 체크해주세요.</ErrorMessage>
          )}

          <ToolWrapper>
            {tools.map(tool => (
              <Checkbox
                style={{
                  minWidth: "10rem",
                }}
                key={tool.name}
                checked={tool.value}
                onChange={() =>
                  setTools(
                    tools.map(t => ({
                      ...t,
                      value: t.name === tool.name ? !t.value : t.value,
                    })),
                  )
                }
              >
                {tool.name}
              </Checkbox>
            ))}
          </ToolWrapper>

          <div style={{ marginTop: "1rem" }}>
            {tools.find(tool => tool.name === "기타" && tool.value) && (
              <TextInput
                maxLength={20}
                control={control}
                name="ai_tool"
                label="사용한 AI"
                placeholder="사용하신 AI를 입력해주세요."
              />
            )}
          </div>
        </section>
      )}

      <section>
        <label>타 공모전 출품 여부</label>

        <p style={{ color: "red" }}>
          ※타 공모전과 중복 응모는 가능하나, 중복 수상은 불가합니다.
        </p>

        <div>
          <Controller
            name="is_submit_other_contest"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  예
                </Checkbox>

                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  아니오
                </Checkbox>
              </>
            )}
          />
        </div>

        {watch("is_submit_other_contest") === true && (
          <div style={{ marginTop: "1rem" }}>
            <TextInput
              control={control}
              name="other_contest_name"
              label="출품한 타 공모전 명"
              placeholder="타 공모전에 중복 출품한 경우, 출품한 공모전 명을 반드시 전부 남겨주시기 바랍니다."
              customMessage={
                <p>
                  타 공모전에 중복 출품한 경우, 출품한 공모전 명을 반드시 전부
                  남겨주시기 바랍니다.
                </p>
              }
            />
          </div>
        )}
      </section>

      <section>
        <label>
          타 공모전과 중복 입상 확인 시, 수상이 취소되고 상금이 환수될 수 있음을
          동의합니다.
        </label>

        <p style={{ color: "red" }}>※비동의 시, 심사 대상에서 제외됩니다.</p>

        <div>
          <Controller
            name="is_agree_other_contest"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  동의
                </Checkbox>

                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  비동의
                </Checkbox>
              </>
            )}
          />
        </div>
      </section>

      <section>
        <label>
          지적재산권을 침해한 작품, 제3자에 대한 초상권 및 타인의 명예를 훼손한
          작품, 타인의 저작물 및 명의를 도용한 경우 수상이 취소되고 상금이
          환수될 수 있음을 동의합니다.
        </label>

        <p style={{ color: "red" }}>※비동의 시, 심사 대상에서 제외됩니다.</p>

        <div>
          <Controller
            name="is_agree_copyright"
            control={control}
            render={({ field }) => (
              <>
                <Checkbox
                  checked={field.value === true}
                  onChange={() => field.onChange(true)}
                >
                  동의
                </Checkbox>

                <Checkbox
                  checked={field.value === false}
                  onChange={() => field.onChange(false)}
                >
                  비동의
                </Checkbox>
              </>
            )}
          />
        </div>
      </section>

      <section>
        <SingleCheckBox
          name="privacy_policy"
          control={control}
          label="개인정보 동의(필수)"
        />

        <CautionWrapper>
          <b>개인정보 수집.이용 동의 (공모전 운영안내) </b>

          <p>
            사단법인 세이브더얼스의 개인정보 수집 이용 목적은 다음과 같습니다
          </p>

          <ul>
            <li>1. 공모전 참가 안내</li>
            <li>2. 이름, 연락처, 이메일</li>
            <li>3. 보유 이용기간 : 수집일로부터 1년까지</li>
          </ul>

          <p>
            귀하는 위와 같이 개인정보를 수집, 이용하는데 동의를 거부할 권리가
            있습니다. 필수 수집항목에 대한 동의를 거절하시는 경우 서비스 이용이
            제한될 수 있습니다
          </p>
        </CautionWrapper>
      </section>

      <CautionWrapper>
        <b>[유 의 사 항]</b>

        <p>- 수상 종류, 상금은 심사 결과에 따라 변동될 수 있음</p>
        <p>- 상금은 일부 세금을 제한 후 지급</p>
        <p>
          - 수상작은 세이브더얼스 홈페이지, SNS, 유튜브 등에서 홍보 목적으로
          활용될 수 있으며, 지적재산권은 상금으로 대체됨
        </p>
        <p>
          - 수상작은 환경 홍보를 위해 필요에 따라 수정, 변형해서 이용될 수 있음
        </p>
        <p>
          - 초상권 및 저작권 등 작품 관련 분쟁 시 민형사상 법적 책임을 비롯한
          모든 책임은 응모자에게 있음
        </p>
        <p>
          - 타 공모전 수상작, 지적재산권 침해 작품, 제3자에 대한 초상권 및
          타인의 명예를 훼손한 작품, 타인의 저작물 및 명의를 도용한 경우 수상이
          취소되고 상금이 환수될 수 있음
        </p>
        <p>- 수상작의 경우 고화질 원본 영상을 제출 필수</p>
        <p>- 수상작 발표 이후 이의 제기 기간 운영, 외부 제보 접수 가능</p>
      </CautionWrapper>
    </CheckboxWrapper>
  );
};

export default ContestCheckBoxGroup;
